import { render, staticRenderFns } from "./TagMapping.vue?vue&type=template&id=5e7ab8a8&scoped=true&"
import script from "./TagMapping.vue?vue&type=script&lang=js&"
export * from "./TagMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7ab8a8",
  null
  
)

export default component.exports